export const mapboxAddressSearchQuery = () =>
  'autocomplete=true&types=address&limit=3&language=en'

export const customAddressChoice = (query: string) => {
  const address = query.trim()
  if (!address) {
    return null
  }
  return { address, coordinates: [] as number[] }
}
